import React from "react";
import { Field, useField } from "formik";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import Select from "react-select";
import { MdKeyboardArrowDown } from "react-icons/md";

export const CustomMultiSelectWField = ({
  fieldName,
  label,
  placeholder,
  visible,
  getOptionLabel,
  getOptionValue,
  autoload,
  isLoading,
  options,
  onChange,
  onFocus,
  mt,
  values,
  width,
  separatorFalse,
  placeholderColor,
  isDisabled,
}) => {
  const customStyles = (form, fieldName) => ({
    placeholder: (provided) => ({
      ...provided,
      color: placeholderColor ? "#1A202C" : "#A0AEC0",
    }),
    menu: (provided) => ({
      ...provided,
      width: width ? width : "100%",
    }),

    indicatorSeparator: (provided) => ({
      ...provided,
      display: separatorFalse ? "none" : "block",
    }),
    control: (provided, state) => ({
      ...provided,
      opacity: isDisabled && "0.7 !important",
      paddingInlineStart: "var(--chakra-space-1)",
      paddingInlineEnd: "0.5rem",
      width: width ? width : "100%",
      minWidth: "0px",
      outline: "2px solid transparent",
      outlineOffset: "2px",
      transitionProperty: "var(--chakra-transition-property-common)",
      transitionDuration: "var(--chakra-transition-duration-normal)",
      background: isDisabled ? "#dbdbdb" : "inherit",
      paddingBottom: "1px",
      lineHeight: "var(--chakra-lineHeights-normal)",
      fontSize: "var(--chakra-fontSizes-md)",
      minHeight: "42px",
      borderRadius: "var(--chakra-radii-md)",
      borderWidth: "1px",
      borderColor: state.isFocused
        ? "var(--chakra-colors-blue-300)"
        : form.errors[fieldName] && form.touched[fieldName]
        ? "var(--chakra-colors-red-500)"
        : isDisabled
        ? "#666"
        : "var(--chakra-colors-gray-200)",
      "&:hover": {
        borderColor:
          form.errors[fieldName] && form.touched[fieldName]
            ? ""
            : "var(--chakra-colors-gray-300)",
      },
      backgroundColor: "var(--chakra-colors-white)",
    }),
  });

  const [, , helpers] = useField(fieldName);

  const handleSelectChange = (selectedOption) => {
    if (selectedOption && selectedOption.length > 0) {
      helpers.setValue([selectedOption]);
    } else {
      helpers.setValue("");
    }
  };
  const DropdownIndicator = () => {
    return <MdKeyboardArrowDown color="#1A202C" size={18} />;
  };

  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl
          name={fieldName}
          isInvalid={form.errors[fieldName] && form.touched[fieldName]}
          id={fieldName}
          mt={mt ? mt : "0px"}
        >
          <FormLabel
            color="#5F6377"
            fontWeight="500"
            whiteSpace={"nowrap"}
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor={fieldName}
          >
            {label}
          </FormLabel>
          {visible ? (
            <Select
              id={`select-${fieldName}`}
              getOptionLabel={getOptionLabel}
              getOptionValue={getOptionValue}
              isLoading={isLoading}
              options={options}
              isMulti
              placeholder={placeholder}
              value={values || ""}
              onChange={(selectedOption) => {
                handleSelectChange(selectedOption);
              }}
              onFocus={onFocus}
              styles={customStyles(form, fieldName)}
              components={{ DropdownIndicator: DropdownIndicator }}
              isDisabled={isDisabled}
            />
          ) : (
            ""
          )}

          <FormErrorMessage>{form.errors[fieldName]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  );
};
